import { GlobalState } from '@leverege/ui-redux';
import { Relationships } from '@leverege/molten/data-source';
import { Types } from "../../constants/index.js";
export default (({
  objectType,
  delegate: DelegateClass,
  relationshipPath
}) => ({
  name: 'imagineGroup',
  objectType,
  valueType: 'imagineGroup',
  get: (data, cxt) => {
    if (!data?.id) {
      return null;
    }
    const relationship = Relationships.getByPath(relationshipPath);
    const delegate = new DelegateClass({
      relationship,
      match: {}
    });
    const imagineGroup = delegate.getImagineGroupItem(GlobalState.get(), data?.id);
    return imagineGroup;
  },
  displayName: 'Imagine Group Name',
  source: {
    type: Types.apiName,
    editable: false,
    creatable: false
  }
}));